import { XdrOverviewController } from '../controller/XdrOverviewController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { XdrOverviewWebComponentSchema } from '../types';

export class XdrOverviewWebComponent extends BaseWebComponentElement {
  public controller: XdrOverviewController;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: XdrOverviewController,
    });
  }

  get incidentData(): XdrOverviewWebComponentSchema {
    const value = this.getAttribute('data-incident-data');
    return value ? JSON.parse(value) : {};
  }

  set incidentData(value: XdrOverviewWebComponentSchema) {
    if (!value) {
      return;
    }
    this.setAttribute('data-incident-data', JSON.stringify(value));
  }

  connectedCallback(): void {
    super.connectedCallback();
  }

  disconnectedCallback(): void {
    this.controller.view.unobserveRiskPanel();
    super.disconnectedCallback();
  }
}
